<template>
    <v-row v-if="! explanation" justify="center">
        <v-skeleton-loader type="image" height="40" width="300"></v-skeleton-loader>
    </v-row>
    <v-pagination
        v-else
        v-model="currentPage"
        :length="explanation.last_page"
    ></v-pagination>
</template>

<script>
import { get, sync } from 'vuex-pathify'

export default {
    computed: {
        explanation: get('explanation/explanation'),
        currentPage: sync('explanation/currentPage'),
    },

    watch: {
        currentPage() {
            this.$vuetify.goTo(0)

            this.$store.dispatch('explanation/getData')
        }
    },
}
</script>
